// extracted by mini-css-extract-plugin
export default {"form":"AuthForm_form__+Hbok","title":"AuthForm_title__YaYnS"};